import React from 'react'

function FromVariable() {
    return (
        <span className='cs-exp-read-var-name'>From Variable (Closest Scope)</span>
    )
}

export { FromVariable }